/* eslint-disable comma-dangle */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './state'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vuelidate from 'vuelidate'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import { AUTH_TOKEN } from './constants/settings'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'
import VueApollo from 'vue-apollo'
import vuepdfmake from './plugins/vue-pdfmake.js'
Vue.use(vuepdfmake)
var uri = 'https://qjhsdjdlkk.click/graphql'

if (process.env.NODE_ENV === 'development') {
  uri = 'http://localhost:5000/graphql'
}

const httpLink = new HttpLink({
  uri: uri,
  fetchOptions: {
    mode: 'cors',
  },
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem(AUTH_TOKEN)
  // return the headers to the context so httpLink can read them
  if (token) {
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    }
  } else {
    return {
      headers: {
        ...headers,
      },
    }
  }
})

// Create the apollo client
const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  connectToDevTools: false,
})

Vue.use(Datetime)
Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  errorHandler (error) {
    console.error(error)
  },
})
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.config.productionTip = process.env.NODE_ENV === 'production'

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (store.state.isAuthenticated) {
      next()
    } else {
      next({ name: 'Login' })
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAdminAuth) {
    if (
      store.state.isAuthenticated &&
      (store.state.role === 'admin' || store.state.role === 'superuser')
    ) {
      next()
    } else {
      next({
        name: 'Login',
      })
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  apolloProvider,
  store,
  template: '<App/>',
  components: { App },
})



// WEBPACK FOOTER //
// ./src/main.js